import { useMutation } from "@apollo/client";
import Button from "components/base/Button.jsx";
import { Alert } from "components/base/Toast";
import { BsPencil, BsTrash } from "react-icons/bs";
import { DELETE_QC_ISSUE } from "../graphql.js";

function Issue({ issue, onEdit }) {
  const [deleteQcIssue] = useMutation(DELETE_QC_ISSUE, {
    variables: { id: issue.id },
    onCompleted() {
      Alert("success", "删除成功");
    },
  });
  return (
    <div className="lg:flex justify-between py-4 border-b relative">
      <div className="absolute z-10 right-0 top-4 flex gap-4">
        <Button onClick={() => onEdit(issue)}>
          <BsPencil />
        </Button>
        <Button
          danger
          onClick={(_) => {
            if (window.confirm("确认删除缺陷？")) deleteQcIssue();
          }}
        >
          <BsTrash />
        </Button>
      </div>
      <div>
        <div
          className={`font-bold
                  ${issue.defectType === "major" ? "text-red-500 " : "text-yellow-500"}`}
        >
          [<span className="uppercase">{issue.defectType}</span>] Defect Code: #
          {issue.defectCode.code}
        </div>
        <div className="flex flex-col gap-2 mt-2">
          {issue.product && (
            <div className="flex">
              <label className="w-32 flex-shrink-0">Product 产品:</label>
              <span className="flex-1">{issue.product.name}</span>
            </div>
          )}

          <div className="flex">
            <label className="w-32 flex-shrink-0">Issue 缺陷:</label>
            <span className="flex-1">{issue.defectCode.description}</span>
          </div>

          <div className="flex">
            <label className="w-32 flex-shrink-0">Quantity 数量:</label>
            <span className="flex-1">✕ {issue.qty}</span>
          </div>

          {issue.factory && (
            <div className="flex">
              <label className="w-32 flex-shrink-0">Supplier 供应商:</label>
              <span className="flex-1">{issue.factory.name}</span>
            </div>
          )}
        </div>
        <div className="space-y-2 mt-2">
          {issue.images.map((image) => (
            <a
              key={image.id}
              href={image.src}
              target="_blank"
              className="w-full block"
              title="Open origin image"
              rel="noopener noreferrer"
            >
              <img
                className="w-full lg:w-auto lg:h-32 bg-gray-700"
                src={`${image.src}?imageView2/2/w/600`}
                alt="issue image"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Issue;
